import Card from '@auteco/components/sharedComponents/Card/Card'
import CardBody from '@auteco/components/sharedComponents/Card/CardBody'
import React, { useEffect, useState, } from 'react'
import Paper from '@material-ui/core/Paper'
import MenuList from '@material-ui/core/MenuList'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import { getGDCClusters, getGDCScore, postProccessOk } from '@auteco/services/gdcServices'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import { Button as MaterialUIButton } from '@material-ui/core'
import { getPermissions } from '@auteco/utils/Common'
import Button from '../../sharedComponents/CustomButtons/Button'

import {
  Bitacora,
  ClusterCardButton,
  ClusterMenuItem,
  QuestCard
} from './components'
import { useStyles } from './styles'
import { Alert } from '../Alert'



const DiscoverySection = ({ selectOption, onCloseOption }) => {
  const classes = useStyles()
  const [clustersList, setClustersList] = useState([])
  const [scoreList, setScoreList] = useState([])
  const [selectCluster, setSelectCluster] = useState(null)
  const [selectedFilter, setSelectedFilter] = useState(null)
  const [alertInfo, setAlertInfo] = useState({ open: false, onClose: () => { }, title: '', content: '', onlyButton: false, btn1Txt: '', btn2Txt: '', btn1Func: () => { }, btn2Func: () => { } })

  const permissions = getPermissions()

  const orderByID = (array) => array.sort((a, b) => Number(a.id_cluster) - Number(b.id_cluster))

  const reloadGDCClusters = () =>
    getGDCClusters({ partner: selectOption.solicitante }).then(
      ({ cluster }) => {
        if (cluster.length > 0) {
          const orderedCluster = orderByID(cluster)
          setClustersList(orderedCluster)
        }
      },
    )

  function groupByID(array) {
    const grupos = array.reduce((acc, obj) => {
      const existingObj = acc.find(item => item.id === obj.id);
      if (existingObj) {
        existingObj[obj.nombre_calificacion] = obj.calificacion;
      } else {
        const newObj = { ...obj };
        newObj[obj.nombre_calificacion] = obj.calificacion;
        acc.push(newObj);
      }
      return acc;
    }, []);

    grupos?.forEach(obj => {
      delete obj.nombre_calificacion;
      delete obj.calificacion;
    });

    return grupos;
  }
  const reloadGDCScore = () =>
    getGDCScore({ partner: selectOption.solicitante }).then(
      ({ socios }) => {
        setScoreList(groupByID(socios))
      },
    )

  useEffect(() => {
    Promise.all([reloadGDCClusters(), reloadGDCScore()]).catch(() => { })
  }, [])

  const organizeScoreList = (searchObj) => {
    if (searchObj) {
      const { cluster_id } = searchObj

      const selectedPoint = clustersList.find((cluster) => cluster.id_cluster === cluster_id)
      const findPoint = scoreList.find((point) => point.id === cluster_id)
      if (selectedPoint) {
        setSelectCluster(selectedPoint)
        setSelectedFilter(() => ({
          ...findPoint,
          ...selectedPoint
        }))
      }
    } else {
      setSelectedFilter(null)
      setSelectCluster(null)
    }
  }

  const sendDiscovery = async () => {
    const body = {
      paso: 1,
      solicitante: selectOption.solicitante
    }
    const response = await postProccessOk({ params: body })
    if (response.success === 1) {
      setAlertInfo({ ...alertInfo, open: false })
      onCloseOption()
    }
  }

  const onSelectCluster = (cluster) => {
    setSelectCluster(cluster)
    reloadGDCScore()
  }

  const finishDiscovery = async () => {
    setAlertInfo(
      {
        open: true,
        onClose: () => setAlertInfo({ ...alertInfo, open: false }),
        title: '!Espera!',
        content: '¿Estás seguro de que deseas terminar este proceso?',
        onlyButton: false,
        btn1Txt: 'Aceptar',
        btn2Txt: 'Cancelar',
        btn1Func: () => sendDiscovery(),
        btn2Func: () => setAlertInfo({ ...alertInfo, open: false })
      })
  }
  return (
    <>
      <Alert info={alertInfo} />
      <section>
        <Card>
          <CardBody>
            <CardTitle
              title="Descubrir"
              subTitle={`${selectOption.razon_social} -  ${selectOption.solicitante}`}
            />
            <Button onClick={onCloseOption}>Volver</Button>
            <div className={classes.gridContainer}>
              <div className={`${classes.gridItem} ${classes.gridItemFirst}`}>
                <Paper className={classes.paper}>
                  <MenuList>
                    {clustersList.map((item) => (
                      <ClusterMenuItem
                        key={item.id}
                        item={item}
                        onSelect={(cluster) => onSelectCluster(cluster)}
                        isSelected={item.id_cluster === selectCluster?.id_cluster}
                      />
                    ))}
                  </MenuList>
                </Paper>
              </div>
              <div className={`${classes.gridItem} ${classes.gridItemSecond}`}>
                <Bitacora
                  partner={selectOption.solicitante}
                  clusterId={selectCluster?.id_cluster}
                  isEnabled={selectOption.isEnabled}
                />
              </div>
              <div className={`${classes.gridItem} ${classes.gridItemThird}`}>
                <div className={classes.itemDetail}>
                  {clustersList?.map((item) => (
                    <ClusterCardButton
                      key={item.id}
                      item={item}
                      onSelect={(cluster) => onSelectCluster(cluster)}
                      isSelected={item.id_cluster === selectCluster?.id_cluster}
                    />
                  ))}
                </div>
                <div className={classes.itemDetailInput}>
                  <Card className={classes.cardAutocomplete}>
                    {scoreList && (
                      <Autocomplete
                        options={scoreList}
                        getOptionLabel={(option) => option.punto}
                        value={selectedFilter?.punto}
                        onChange={(event, newValue) =>
                          organizeScoreList(newValue)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Buscar"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {params.InputProps.endAdornment}
                                  <span style={{ marginLeft: '10px' }}>{selectedFilter?.nombre && selectedFilter?.nombre}</span>
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    )}
                  </Card>
                </div>
                <div className={classes.itemDetailQuestions}>
                  {scoreList?.map((quest) => {
                    const isVisible = quest.cluster_id === selectCluster?.id_cluster
                    return (
                      <>
                        {isVisible && (
                          <QuestCard
                            key={quest.id}
                            quest={quest}
                            partner={selectOption.solicitante}
                            isEnabled={selectOption.isEnabled}
                            reloadGDCClusters={reloadGDCClusters}
                          />
                        )}
                      </>
                    )
                  })}
                </div>
              </div>
            </div>
            {permissions[58] === 5 &&
              <MaterialUIButton
                variant='contained'
                color='primary'
                className={classes.finishBtn}
                disabled={!selectOption.isEnabled}
                onClick={finishDiscovery}
              >
                Finalizado
              </MaterialUIButton>
            }
          </CardBody>
        </Card>
      </section>
    </>
  )
}

export { DiscoverySection }
